module.exports = __webpack_public_path__ + "static/media/scroll02_0_3x.f82d7ad7.png";